export default "__VITE_ASSET__BQBwtkQU__"